import { createFileRoute } from '@tanstack/react-router';
import { FinanceiroPrevisaoSucumbenciaShell } from '../components/financeiro/FinanceiroPrevisaoSucumbenciaShell';

export const Route = createFileRoute('/w/$workspaceId/financeiro/previsao-sucumbencia')({
  component: PrevisaoSucumbenciaPage,
});

function PrevisaoSucumbenciaPage() {
  const { workspaceId } = Route.useParams();
  return <FinanceiroPrevisaoSucumbenciaShell workspaceId={workspaceId} />;
}
